import { joinURL } from 'ufo';

export function getImage(src, { modifiers, baseURL } = {}, { options, $img }) {
  let { width, height, format, fit, quality, ...providerModifiers } = modifiers;

  if (!format) {
    // get extension from src
    const extension = src.split('.').pop();
    format = extension === 'jpg' ? 'jpeg' : extension;
  }

  const operations = [`quality=${quality}`, `width=${width}`, `height=${height}`, `format=${format}`, `fit=cover`];

  const operationsString = operations.join(',');

  return {
    url:
      import.meta.env.NUXT_SITE_ENV === 'production'
        ? joinURL(`https://www.artnight.com/cdn-cgi/image/`, operationsString, src)
        : src
    // if local images during dev
    // url: src
  };
}
